import _setPrototypeOf from './setPrototypeOf.js';

function _inheritsLoose(subClass, superClass) {
  subClass.prototype = Object.create(superClass.prototype);
  subClass.prototype.constructor = subClass;
  _setPrototypeOf(subClass, superClass);
}

export { _inheritsLoose as default };
//# sourceMappingURL=inheritsLoose.js.map
